import React, { useState } from "react";
import { Card, Form, Input, Button, Typography, message } from "antd";
import {
  MobileOutlined,
  LockOutlined,
  SafetyCertificateOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import "./style.css";
import { loginauth } from "../../services/authService";

const { Title } = Typography;

const Login = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  //Handle Login
  const onFinish = async (values) => {
    debugger
    try {
      setLoading(true);

      const res = await loginauth(values);  
      console.log("response : ",res.data);
      if(res.data.status==200){
        // Save token
        localStorage.setItem("token", res.data.accessToken);
        message.success("Login Success");
        // Dashboard redirect
        navigate("/admin");
      }else{
        message.error(res.data.message);
      }

    } catch (error) {
      message.error(
        error.response?.data?.message || "Login Failed"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">

      <header className="login-header">
        <SafetyCertificateOutlined className="logo-icon" />
        <span>Steel City Press CMS</span>
      </header>

      <div className="login-body">

        <div className="left-panel">
          <h1>Welcome Back 👋</h1>
          <p>
            Manage Recent Works, Teams, Machineries & Customer Feedbacks
            from one powerful admin dashboard.
          </p>
        </div>

        <div className="right-panel">
          <Card className="login-card" hoverable>
            <Title level={3} className="login-title">
              Login
            </Title>

            <Form layout="vertical" onFinish={onFinish}>
              <Form.Item
  label="Mobile"
  name="mobile"
  rules={[
    { required: true, message: "Please enter mobile number" },
    { pattern: /^[0-9]+$/, message: "Only numbers allowed" },
    { len: 10, message: "Mobile number must be 10 digits" },
  ]}
>
  <Input
    prefix={<MobileOutlined />}
    placeholder="Enter mobile number"
    size="large"
    maxLength={10}
  />
</Form.Item>

<Form.Item
  label="Password"
  name="password"
  rules={[
    { required: true, message: "Please enter password" },
    { min: 6, message: "Password must be at least 6 characters" },
  ]}
>
  <Input.Password
    prefix={<LockOutlined />}
    placeholder="Enter password"
    size="large"
  />
</Form.Item>


              <Button
                type="primary"
                htmlType="submit"
                block
                size="large"
                loading={loading}
              >
                Login
              </Button>

              <div className="reset-link">
                {/* <Link to="/reset-password">
                  <Button type="link">Reset Password</Button>
                </Link> */}
              </div>
            </Form>

          </Card>
        </div>

      </div>
    </div>
  );
};

export default Login;
